import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import MuiPopper from '@mui/material/Popper';

var Popper = /*#__PURE__*/React__default.forwardRef(function (props, ref) {
  return props.open ? /*#__PURE__*/React__default.createElement(MuiPopper, _extends({
    ref: ref
  }, props)) : null;
});

export { Popper as default };
//# sourceMappingURL=index.js.map
